const kstTimeFormatter = new Intl.DateTimeFormat('ko-KR', {
	timeZone: 'Asia/Seoul',
	hour: '2-digit',
	minute: '2-digit',
	second: '2-digit',
	hourCycle: 'h23'
});

export function formatKstServerTime(epochMillis: number): string {
	return kstTimeFormatter.format(new Date(epochMillis));
}

export function getServerTimeOffsetMs({
	serverEpochMillis,
	clientEpochMillis
}: {
	serverEpochMillis: number;
	clientEpochMillis: number;
}): number {
	return serverEpochMillis - clientEpochMillis;
}
